import './dashboard.scss';



import TopBox from '../../components/topBox/TopBox';

function Dashboard() {
  return (
    <div className='d-board'>
      

      <div className="box box1"><TopBox/></div>
      <div className="box box2"> <h1>Welcome back to Shisha Control Panel</h1></div>
      <div className="box box3"></div>
      <div className="box box4"></div>
      <div className="box box5"></div>
      <div className="box box6"></div>
      <div className="box box7"></div>
      <div className="box box8"></div>
      <div className="box box9"></div>
    </div>
  )
}

export default Dashboard